import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { authApi } from '../services/api';
import { MailCheck } from 'lucide-react';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Something went wrong');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="py-16">
      <div className="container-max max-w-md mx-auto">
        <h1 className="text-3xl font-serif font-bold text-coastal-600 mb-2 text-center">
          Forgot Password
        </h1>
        <p className="text-gray-600 text-center mb-8">
          Enter your email and we&apos;ll send you a link to reset your password.
        </p>

        <Card>
          <CardContent className="pt-6">
            {sent ? (
              <div className="text-center space-y-4">
                <MailCheck className="w-12 h-12 text-coastal-600 mx-auto" />
                <p className="text-gray-700">
                  If an account exists for <span className="font-medium">{email}</span>, a password
                  reset link is on its way. The link expires in 1 hour.
                </p>
                <Link to="/account" className="text-coastal-600 font-medium hover:underline inline-block">
                  Back to sign in
                </Link>
              </div>
            ) : (
              <>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-3 py-2 border rounded-lg"
                      required
                    />
                  </div>
                  {error && <p className="text-red-600 text-sm">{error}</p>}
                  <Button type="submit" className="w-full" disabled={submitting}>
                    {submitting ? 'Please wait...' : 'Send reset link'}
                  </Button>
                </form>
                <div className="mt-4 text-center text-sm text-gray-600">
                  Remembered it?{' '}
                  <Link to="/account" className="text-coastal-600 font-medium hover:underline">
                    Sign in
                  </Link>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
